import { render, staticRenderFns } from "./ConvertOldData.vue?vue&type=template&id=779450b8"
import script from "./ConvertOldData.vue?vue&type=script&lang=js"
export * from "./ConvertOldData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports